if (!customElements.get('hoculus-product-addon')) {
    class HoculusProductAddon extends HTMLElement {
        constructor() {
            super()
            this.checkbox = this.querySelector("input[type=checkbox]")
            this.inputs = this.querySelectorAll("input[type=hidden]")
            this.productForm = document.querySelector("form.js-product-form-main")
            this.checkbox.addEventListener("input", this.onCheckboxChange.bind(this))
        }

        onCheckboxChange() {
            const isChecked = this.checkbox.checked;
            if (isChecked) this.inputs.forEach(input => this.productForm.appendChild(input))
            else this.inputs.forEach(input => this.productForm.removeChild(input))
        }
    }

    customElements.define('hoculus-product-addon', HoculusProductAddon);
}